/* eslint-disable */
import {http} from '@/helpers/http';

const defaultAdvantageObject = {
    id: 'new',
    is_active: false,
    sort: '',
    title: '',
    subtitle: '',
    description: '',
    use_in_filter: false,
    filter_title: '',
};

export default {
    namespaced: true,

    state() {
        return {
            list: [], // Список банков
            search: '', // Поисковое слово в списке
            current: defaultAdvantageObject,
        };
    },

    mutations: {
        /* Записать новый список */
        setList(state, data) {
            state.list = data.slice();
        },

        /* Установить поисковое слово */
        setSearch(state, data) {
            state.search = data;
        },

        /* Установить свойство текущего объекта */
        setValue(state, payload) {
            state.current = {
                ...state.current,
                ...payload
            }
        },

        /* Очистить текущее значение */
        clearCurrent(state) {
            state.current = {
                ...state.current,
                ...defaultAdvantageObject
            }
        },

        /* Удалить из списка */
        removeFormList(state) {
            const index = state.list.findIndex(({id}) => id === state.current.id);
            state.list.splice(index, 1);
        },

        /* Установить текущий объект по идентификатору */
        setCurrent(state, _id) {
            const bank = state.list.find(({id}) => id === _id)
            state.current = {
                ...state.current,
                ...bank
            }
        },

        /* Заменить по идентификатору */
        replaceById(state, current) {
            const index = state.list.findIndex(({id}) => id === current.id);
            state.list.splice(index, 1, current);
        },

        /* Добавить в список */
        addList(state, current) {
            state.list.push({...current, id: state.list.length + 1});
        }
    },

    getters: {
        getItems: state => state.list.map(item => {
            return {
                id: item.id,
                title: item.title
            }
        }),

        getList: state => state.list
            .filter(({title}) => title.toLowerCase().indexOf(state.search.toLowerCase()) >= 0)
            .map(({id, title, subtitle, updated_at_formatted, is_active, use_in_filter}) => {
                return {
                    id,
                    title,
                    is_active: is_active ? 'Да' : 'Нет',
                    subtitle,
                    updated_at: updated_at_formatted,
                    use_in_filter: use_in_filter ? 'Да' : 'Нет',
                };
            }),

        getById: state => _id => state.list.find(({id}) => id === _id),

        getCurrent: state => state.current,

        getFormatList: (state, getters) => {
            return getters.getList.map(obj => ({
                ...obj,
                is_active: obj.is_active ? 'Да' : 'Нет',
                use_in_filter: obj.use_in_filter ? 'Да' : 'Нет',
            }))
        }
    },

    actions: {
        async getList({commit}) {
            try {
                const {data} = await http.post('/admin/advantages');
                commit('setList', data);
            } catch (e) {
                throw e;
            }
        },

        async remove({commit}, id) {
            await http.post('/admin/advantages/remove', {id});
            commit('clearCurrent');
        },

        async getById({commit}, id) {
            if (id === null || id === 'new') {
                commit('clearCurrent');
                return;
            }

            const {data} = await http.post('/admin/advantages/edit', {id});
            commit('setValue', data);
        },

        async save({state}) {
            // Это новый элемент или редактирование?
            const isNew = state.current.id === 'new' || state.current.id === null;

            if (!isNew) {
                const {data: id} = await http.post('/admin/advantages/store', {
                    id: state.current.id,
                    title: state.current.title,
                    subtitle: state.current.subtitle,
                    is_active: state.current.is_active,
                    sort: +state.current.sort,
                    description: state.current.description,
                    use_in_filter: state.current.use_in_filter,
                    filter_title: state.current.filter_title,
                });
                return id;
            } else {
                const {data: id} = await http.post('/admin/advantages/store', {
                    title: state.current.title,
                    subtitle: state.current.subtitle,
                    is_active: state.current.is_active,
                    sort: +state.current.sort,
                    description: state.current.description,
                    use_in_filter: state.current.use_in_filter,
                    filter_title: state.current.filter_title,
                });
                return id;
            }
        }
    },
};
